export const ALL = 'all';

export const ADMIN = 'admin';

export const ADVISER = 'advisers';

export const CLIENT = 'clients';
